import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Optionnel : vérifier la session auprès du backend
    if (sessionId) {
      // Vous pouvez faire un appel API ici pour vérifier la session
      console.log('Session ID:', sessionId);
    }
  }, [sessionId]);

  return (
    <div style={{
      maxWidth: '600px',
      margin: '4rem auto',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <Helmet>
        <title>Abonnement activé - EdenPlaisir.com</title>
        <meta name="description" content="Votre abonnement a été activé avec succès sur EdenPlaisir.com." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div style={{
        width: '80px',
        height: '80px',
        margin: '0 auto 2rem',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 20 20"
          fill="white"
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      <h1 style={{
        fontSize: '2rem',
        fontWeight: '700',
        color: '#1a1a1a',
        marginBottom: '1rem'
      }}>
        Abonnement activé !
      </h1>

      <p style={{
        fontSize: '1.125rem',
        color: '#666',
        marginBottom: '2rem'
      }}>
        Merci pour votre abonnement. Vous avez maintenant accès à tous les contenus premium !
      </p>

      <div style={{
        display: 'flex',
        gap: '1rem',
        justifyContent: 'center'
      }}>
        <button
          onClick={() => navigate('/subscriptions')}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            background: 'white',
            color: '#374151',
            fontWeight: '500',
            cursor: 'pointer'
          }}
        >
          Gérer mes abonnements
        </button>
        
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
            color: 'white',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Découvrir le contenu
        </button>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;


